module.exports = __webpack_public_path__ + "img/nav-3-active.65b7e43.png";